import windowutils from '../utils/window';
import analytics from '../utils/analytics';
import { debounce } from 'debounce';

export default class Tiles {
  constructor(el = '.tileContainer') {
    this.tileelement = el;

    this.tileelementselector =
      this.tileelement === '.tileContainer'
        ? '.tileContainer:not(.tile-hold)'
        : this.tileelement; //if tileelement is .tileContainer, use .tileContainer:not(.tile-hold) to avoid holding tiles

    // this.excludedtiles = ['plain','videoTile','news', 'twitter'];
    this.rowclass = `${this.tileelement.replace('.', '')}-row`;
    this.tilecolumnel = '.tile-column';

    this.targetspan = 12;
    this.defaultcolspan = '6';
    // caches
    this.tiles = [];
    this.tilerows = [];
    this.tilecolumns = [];

    this.tilegroups = [];
    this.hasicon = false;
    this.singlelink = false;
    this.mediaquery = windowutils.currentmediaquery();
    this.parseTileLinks =
      typeof window.parseTileLinks !== 'undefined' &&
      window.parseTileLinks === false
        ? false
        : true;

    // helper bound methods
    this.refreshCaches = this.refreshCaches.bind(this);

    try {
      this.initialize();
    } catch (error) {
      console.log(error);
    }
  }

  initialize() {
    this.mapcolumns();
    // refresh caches after mapping columns
    this.refreshCaches();

    // Debounced resize handling to avoid excessive mediaquery checks
    this._onResize = debounce(() => {
      const newMedia = windowutils.currentmediaquery();
      if (newMedia !== this.mediaquery) {
        this.mediaquery = newMedia;
        this.mediaquerychange();
      }
    }, 250);
    window.addEventListener('resize', this._onResize);
    this.preparsed = false;

    // Collect tiles that need to be moved
    const tilesToMove = [];
    this.tiles.forEach((tile) => {
      if (tile.parentNode.classList.contains(this.rowclass)) {
        tilesToMove.push(tile);
        this.preparsed = true;
      }
    });

    // Batch move all tiles at once using a DocumentFragment to minimize reflows
    if (tilesToMove.length > 0) {
      const targetRow = tilesToMove[0].parentNode;
      const frag = document.createDocumentFragment();
      tilesToMove.forEach((tile) => frag.appendChild(tile));
      targetRow.parentNode.insertBefore(frag, targetRow);
    }

    if (this.preparsed) {
      this.tilerows.forEach((el) => {
        el.parentNode.removeChild(el);
      });
    }

    this.maptiles(this.tiles);
    this.wraptiles();
    // caches updated by wraptiles
    this.mediaquerychange();
    try {
      this.trackContent();
    } catch (e) {
      console.log(e);
    }
  }

  mediaquerychange() {
    this.mediaquery = windowutils.currentmediaquery();
    this.assignclasses();
    // use cached tilerows when available
    this.refreshCaches();
    this.tilerows.forEach((row) => {
      row.classList.toggle('medium', this.mediaquery === 'medium');
    });
  }

  // refreshCaches updates internal query caches for tiles, rows and columns
  refreshCaches() {
    this.tiles = [...document.querySelectorAll(this.tileelementselector)];
    this.tilerows = [...document.querySelectorAll('.tileRow')];
    this.tilecolumns = [...document.querySelectorAll(this.tilecolumnel)];
  }
  watchImage(tileimage) {
    const image = tileimage.querySelector('img');
    if (!image) return;
    // Prefer native lazy loading when available; keep the loaded class handling as a visual hook
    if (!image.hasAttribute('loading')) {
      image.setAttribute('loading', 'lazy');
    }
    if (image.complete) {
      image.classList.add('loaded');
    } else {
      image.addEventListener('load', (e) => {
        e.target.classList.add('loaded');
      });
    }
  }
  assignclasses() {
    // Instrumentation: mark start
    if (typeof performance !== 'undefined' && performance.mark) {
      try {
        performance.mark('tiles-assignclasses-start');
      } catch (e) {}
    }

    const stripClassNames = ['large-6', 'medium-4', 'medium-6', 'medium-8'];

    // We'll perform reads first and batch writes to reduce layout thrashing
    const writeActions = [];

    this.tilegroups.forEach((tiles) => {
      const tilecount = tiles.length;

      // Read phase: gather desired changes
      tiles.forEach((tile, i) => {
        if (tile.classList.contains('hide')) return;

        const action = {
          tile,
          remove: [...stripClassNames],
          add: [],
          style: [],
          textAdds: [],
          imageAdds: [],
          watchImageEls: [],
        };

        // read-only data
        const colspan = tile.dataset.colspan ? tile.dataset.colspan : this.defaultcolspan;
        const tileimage = tile.querySelector('.tileImage');
        const tiletext = tile.querySelector('.tileText') || false;

        // if tiletext empty -> hide via style
        try {
          if (tiletext && tiletext.innerHTML.trim().length === 0) {
            action.style.push({ el: tiletext, prop: 'display', value: 'none' });
          }
        } catch (e) {
          console.log(e, 'error at tile');
        }

        // watch image if present
        try {
          if (tileimage && tileimage.querySelector('img')) {
            action.watchImageEls.push(tileimage);
          }
        } catch (e) {
          console.log(e, 'error at tileimage');
        }

        // small-heading
        try {
          if (colspan === '3' && tiletext && tiletext.querySelector('h2, h3, h4, h5, h6')) {
            action.textAdds.push({ el: tiletext, classes: ['small-heading'] });
          }
        } catch (e) {}

        if (tiletext && i !== 2 && !tiletext.classList.contains('banner')) {
          if (colspan === '12' && !tile.dataset.noimage) {
            action.add.push('medium-12');
            action.add.push(`large-${colspan}`);
            if (tile.dataset.fiftyFull && tile.dataset.fiftyFull === 'true') {
              action.add.push('isfiftyfull');
              if (tiletext) action.textAdds.push({ el: tiletext, classes: ['large-6', 'columns'] });
              if (tileimage) action.imageAdds.push({ el: tileimage, classes: ['large-6', 'columns'] });
            } else {
              if (tileimage) action.imageAdds.push({ el: tileimage, classes: ['large-8', 'columns'] });
              if (tiletext && !tiletext.classList.contains('search')) action.textAdds.push({ el: tiletext, classes: ['large-4', 'columns'] });
            }
          } else {
            action.add.push(`large-${colspan}`);
            action.add.push('medium-6');
          }
        } else {
          if (colspan == '3' && tilecount != 3) {
            action.add.push('medium-6');
            action.add.push('is-four-column');
          } else {
            action.add.push('medium-12');
          }
          action.add.push(`large-${colspan}`);
        }

        writeActions.push(action);
      });

      // Write phase: apply all accumulated actions for this group
      writeActions.splice(0).forEach((action) => {
        const { tile, remove, add, style, textAdds, imageAdds, watchImageEls } = action;
        // remove classes
        try {
          remove.forEach((cn) => tile.classList.remove(cn));
        } catch (e) {}
        // add classes
        try {
          add.forEach((cn) => tile.classList.add(cn));
        } catch (e) {}
        // apply style changes
        style.forEach((s) => {
          try {
            s.el.style[s.prop] = s.value;
          } catch (e) {}
        });
        // apply text specific class additions
        textAdds.forEach((ta) => {
          try {
            ta.el.classList.add(...ta.classes);
          } catch (e) {}
        });
        // apply image specific class additions
        imageAdds.forEach((ia) => {
          try {
            ia.el.classList.add(...ia.classes);
          } catch (e) {}
        });
        // watch images after changes
        watchImageEls.forEach((we) => {
          try {
            this.watchImage(we);
          } catch (e) {}
        });
      });
    });

    // Instrumentation: mark end for assignclasses
    if (typeof performance !== 'undefined' && performance.mark && performance.measure) {
      try {
        performance.mark('tiles-assignclasses-end');
        performance.measure('tiles-assignclasses', 'tiles-assignclasses-start', 'tiles-assignclasses-end');
      } catch (e) {}
    }
  }

  mapcolumns() {
    const tilecolumns = [...document.querySelectorAll(this.tilecolumnel)];
    if (tilecolumns.length > 0) {
      tilecolumns.forEach((column) => {
        //find tiles and strip tile classes
        const tiles = [...column.querySelectorAll(this.tileelementselector)];
        tiles.forEach((tile) => {
          tile.removeAttribute('class');
          tile.classList.add('tile-column-child');
        });
        column.classList.add('tileContainer');
        column.classList.add('columns');
        column.classList.add('large-4');
      });
      // update caches
      this.tiles = [...document.querySelectorAll(this.tileelementselector)];
      this.tilecolumns = tilecolumns;
    }
  }

  maptiles(tiles) {
    // Instrumentation: mark start
    if (typeof performance !== 'undefined' && performance.mark) {
      try {
        performance.mark('tiles-maptiles-start');
      } catch (e) {}
    }

    let span = 0;
    let tilearray = [];
    tiles.forEach((tile) => {
      // cache commonly used sub-elements on this iteration
      const tileEl = tile.querySelector('.tile');
      const tileTextEl = tile.querySelector('.tileText');
      const tileImageEl = tile.querySelector('.tileImage');
      //check for .tileRow in parent and remove parent div if class exists

      if (!tile.classList.contains('hide')) {
        try {
          //find span class tile-icon
          const tileIcon = tile.querySelector('.tile-icon');
          if (tileIcon) {
            //use a resize observer to monitor img height
            const tilewraplink = tile.querySelector('.tilewraplink');
            if (this.singlelink && tilewraplink) {
              tilewraplink.classList.add('has-icon');
            }
            this.hasicon = true;
            const spacer = tile.querySelector('.tile-icon-spacer');
            const img = tileIcon;
            //create resizeobserver
            let resizeObserver = new ResizeObserver((entries) => {
              //get element height
              let height = entries[0].contentRect.height;
              spacer.style.height = `calc(100% - ${height}px)`;
            });
            resizeObserver.observe(img);
          }
        } catch (e) {
          console.error(e);
        }
        let fullwidth = false;
        if (tile.dataset.colspan) {
          span = span + parseInt(tile.dataset.colspan);
          parseInt(tile.dataset.colspan) == 12 ? (fullwidth = true) : false;
        } else {
          span = span + parseInt(this.defaultcolspan);
        }

        if (fullwidth) {
          const tileText = tile.querySelector('.tileText');
          const tileImage = tile.querySelector('.tileImage');
          if (
            tile.querySelector('.tileImage') &&
            !tile.querySelector('.videoTile')
          ) {
            !tile.querySelector('.tileImage').querySelector('img') &&
            tile.querySelector('.tileText')
              ? tile.querySelector('.tileText').classList.add('large-12')
              : false;
            if (tile.dataset.imageRight && tile.dataset.imageRight === 'true') {
              let imageclone = tile.querySelector('.tileImage').cloneNode(true);
              imageclone.classList.add('hide-for-small-only');
              if (
                !tile.dataset.fiftyFull ||
                !tile.dataset.fiftyFull === 'true'
              ) {
                imageclone.classList.remove('large-6');
                imageclone.classList.add('large-8');
              } else {
                imageclone.classList.add('large-6');
              }
              imageclone.classList.add('columns');
              tile
                .querySelector('.tileImage')
                .classList.add('show-for-small-only');
              tile
                .querySelector('.tileText')
                .insertAdjacentElement('afterend', imageclone);
              this.watchImage(imageclone);
            }
            if (
              tileText.textContent.trim() === '' &&
              tileImage.querySelector('img')
            ) {
              tileText.remove();
              tileImage.classList.add('large-12', 'medium-12', 'small-12');
              tileImage.classList.remove('large-8', 'columns');
            }
          }
        }

        //find li with no a and add class
        try {
          if (!tile.querySelector('.link-replaced')) {
            [...tile.querySelectorAll('li')].map((el) => {
              el.querySelector('a') ? false : el.classList.add('no-link');
            });
          }
        } catch (error) {
          console.log(error);
        }
        const checkmultilinks = function (links) {
          let linkhref = '';
          let uniquelinks = true;
          if (links.length !== 0) {
            [...links].forEach((link, i) => {
              if (i === 0) {
                linkhref = link.getAttribute('href');
              }
              if (
                link.getAttribute('href') !== linkhref ||
                link.classList.contains('tile-not-expanded')
              ) {
                uniquelinks = false;
              }
            });
          }
          return uniquelinks;
        };
        const replacelinks = function (links) {
          [...links].forEach((el) => {
            let linkclass;
            el.querySelector('img')
              ? (linkclass = '')
              : (linkclass = 'link-replaced');
            if (!el.classList.contains('calltoaction')) {
              let replacementel =
                el.parentNode.tagName === 'P' &&
                !el.parentNode.classList.contains('calltoaction') &&
                !el.parentNode.classList.contains('no-bullet')
                  ? `<ul><li><span class="${linkclass}">${el.innerHTML}</span></li></ul>`
                  : `<span class="${linkclass}">${el.innerHTML}</span>`;
              el.insertAdjacentHTML('afterend', replacementel);
              el.parentNode.removeChild(el);
            }
          });
        };
        try {
          let tileElement = tile.querySelector('.tile');
          const tileLinks = [
            ...tile.querySelectorAll(
              'a:not(.content-anchor):not(#uofg-575 > a)'
            ),
          ];
          if (tileElement) {
            let classList = tileElement.classList;
            if (
              tile.querySelector('.tileText') &&
              tileLinks.length >= 1 &&
              checkmultilinks(tileLinks) &&
              !classList.contains('plain') &&
              !classList.contains('videoTile') &&
              !classList.contains('modalTile') &&
              !classList.contains('twitter') &&
              !classList.contains('tile-07') &&
              !classList.contains('black') &&
              !classList.contains('event') &&
              this.parseTileLinks &&
              !tile.querySelector('.calltoaction') &&
              !tile.querySelector('.banner') &&
              !tile.parentNode.classList.contains('.no-bullet') &&
              !classList.contains('podcast-tile') &&
              !tile
                .getElementsByTagName('a')[0]
                .classList.contains('no-tile-wrap') &&
              !tile
                .getElementsByTagName('a')[0]
                .classList.contains('twitter-timeline') //twitter embed workaround
            ) {
              if (
                tile.querySelector('.tile .tileText').childElementCount === 1 &&
                !tile.querySelector('.tile .tileImage img') &&
                !tile.querySelector('.calltoaction')
              ) {
                tile
                  .querySelector('.tile .tileText')
                  .classList.add('single-child');
              }
              let link = tileLinks[0];
              let url = link.getAttribute('href');
              let linklabel = tile.textContent.trim();
              let ga = link.dataset.ga;
              tile
                .querySelector('.tileText')
                .setAttribute('aria-hidden', 'true');
              tile
                .querySelector('.tileImage')
                .setAttribute('aria-hidden', 'true');
              replacelinks(tile.getElementsByTagName('a'));
              let oldinner = tile.querySelector('.tile').innerHTML;
              const uofg575 = document.getElementById('uofg-575');
              if (!uofg575) {
                this.singlelink = true;
              }

              let newinner = `<a class="tilewraplink ${this.hasicon ? `has-icon` : ``}" aria-label="${linklabel}" ${ga ? `data-ga="${ga}"` : ''} href="${url}">${oldinner}</a>`;
              let el = tile.querySelector('.tile');

              let temp = document.createElement('div');
              temp.innerHTML = newinner;
              el.textContent = '';
              el.insertAdjacentHTML('beforeend', temp.innerHTML);
            }
          }
        } catch (error) {
          console.error(error);
        }

        try {
          let siblingclasslist = [];
          tile.nextElementSibling
            ? (siblingclasslist = [...tile.nextElementSibling.classList])
            : false;
          if (!tile.classList.contains('hide')) {
            if (
              span >= this.targetspan ||
              !siblingclasslist.includes(this.tileelement.replace('.', ''))
            ) {
              tilearray.push(tile);
              this.tilegroups.push(tilearray);
              tilearray = [];
              span = 0;
            } else {
              tilearray.push(tile);
            }
          }
        } catch (error) {
          console.error(error);
        }
      }
    });
    if (tilearray.length > 0) {
      this.tilegroups.push(tilearray);
    }
    // Instrumentation: mark end for maptiles
    if (typeof performance !== 'undefined' && performance.mark && performance.measure) {
      try {
        performance.mark('tiles-maptiles-end');
        performance.measure('tiles-maptiles', 'tiles-maptiles-start', 'tiles-maptiles-end');
      } catch (e) {}
    }
    return;
  }

  wraptiles() {
    this.tilegroups.forEach((group, i) => {
      let container = document.createElement('div');
      container.classList.add('row');
      container.classList.add('tileRow');
      container.classList.add(this.rowclass);
      container.classList.add('tilegroup-' + i);
      if (i === 0) {
        container.classList.add('first-tile-row');
      }
      // Insert container before the first element, then batch-append group children via a fragment
      group[0].parentNode.insertBefore(container, group[0]); //insert contained tiles before group
      const frag = document.createDocumentFragment();
      group.forEach((el) => {
        el.querySelector('#coursefinder')
          ? container.classList.add('first-tile-row')
          : false;
        if (el.querySelector('.autocomplete-fix')) {
          container.classList.add('autocomplete-fix-next');
          container.parentNode.classList.add('autocomplete-fix');
          container.parentNode.parentNode.classList.add('autocomplete-fix');
        }
        frag.appendChild(el);
      });
      container.appendChild(frag);
    });

    // update cached tilerows
    this.tilerows = [...document.querySelectorAll('.tileRow')];
    let fixindex = false;
    this.tilerows.forEach((el, i) => {
      if (el.classList.contains('autocomplete-fix-next')) {
        fixindex = i + 1;
      }
    });
    fixindex ? this.tilerows[fixindex].classList.add('autocomplete-fix') : false;
    return;
  }

  trackContent() {
    const seek = [
      'lavendar',
      'lavender',
      'pillarbox',
      'thistle',
      'cobalt',
      'leaf',
    ];
    // use cached tiles
    this.tiles.forEach((tile) => {
      const tileEl = tile.querySelector('.tile');
      if (!tileEl) return;
      const containsclasses = seek.filter((colour) => {
        return tileEl.classList.contains(colour);
      });
      if (containsclasses.length > 0) {
        let largetile = false;
        [...tile.querySelectorAll('.tileText>p')].forEach((el) => {
          const wordcount = el.textContent.split(' ').filter((word) => {
            return word !== '' && word !== '\n';
          }).length;
          if (wordcount > 70) {
            largetile = true;
          }
        });
        if (largetile) {
          setTimeout(
            analytics.logevent('large tile', 'view', tile.dataset.contentid),
            1000
          );
        }
      }
    });
  }
}
